import { Event } from '../Event'
import { Identity } from '../../constants'

export interface UserRegisteredEventProperties {
  user_id: string
  path_flow_id?: string
  context:
    | 'register'
    | 'path-complete'
    | 'path-create'
    | 'sms-modal'
    | 'sign-in-modal'
    | 'guest-checkout'
    | 'prefill-sms-modal'
}

export class UserRegisteredEvent extends Event<UserRegisteredEventProperties> {
  static displayName = 'User Registered'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
